export enum BookingType {
   CLASSROOM = 'Classroom',
   COURSE = 'Course',
   SERVICE = 'Service'
}

export enum BookingTypeForRoutes {
  CLASSROOM = 'kurs',
  COURSE = 'nettkurs',
  SERVICE = 'tjeneste'
}
